import { env, apimKey } from "../../../config";
import { SERVICE_TYPE } from "../../../types";
import log from "../../../utils/log";

export default async function fetchTimeslotsAsync({
  uuid,
  agentCode,
  postCode,
  dayCount,
  storeNo,
  queueId,
}) {
  log("fetchTimeslotsAsync", "request", ...arguments);

  const baseUrl = `https://apim-ikeasa.azure-api.net/GetTMSSlots/${env}/v2/`;
  const response = await fetch(baseUrl, {
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apimKey,
    },
    method: "post",
    body: JSON.stringify({
      AgentCode: agentCode, //"PL-KIT-O",
      OrderNumber: uuid, //"1000000001",
      PostCode: postCode, // "10100003119",
      SlotsToShow: dayCount, //"30",
      StoreNo: storeNo, // "505",
      QueueId: queueId, // "64aa8a7f-a616-44e8-806a-165e08d91192"
    }),
  });

  if (response.status === 200) {
    const json = await response.json();
    log("fetchTimeslotsAsync", "response", json);
    const timeslots = [];

    // ResponseCode 421 means no timeslots should be displayed no matter what was returned in Array.
    if (
      json.timeslots !== undefined &&
      json.ResponseCode !== "421" &&
      json.timeslots.length > 0
    ) {
      let counter = 0;
      json.timeslots.forEach((ts) => {
        if (json.ServiceType.toUpperCase() === SERVICE_TYPE.OMBORI) {
          // OMBORI
          //const actual_date = ts.start.split("T")[0] + "T00:00:00";
          //const start_time = ts.start.split("T")[1].split(".")[0];
          //const end_time = ts.end.split("T")[1].split(".")[0];
          //const date = ts.start.split("T")[0].replaceAll("-", "");

          // using startLocal/endLocal instead of start and end
          const actual_date = ts.startLocal.split("T")[0] + "T00:00:00";
          const start_time = ts.startLocal.split("T")[1].split("+")[0];
          const end_time = ts.endLocal.split("T")[1].split("+")[0];
          const date = ts.startLocal.split("T")[0].replaceAll("-", "");
          const slotStart = ts.startLocal.split("+")[0];
          const slotEnd = ts.endLocal.split("+")[0];

          counter++;

          timeslots.push({
            id: date + "_" + counter,
            date: date,
            actual_date: actual_date,
            start_time: start_time,
            end_time: end_time,
            slotstart: slotStart,
            slotend: slotEnd,
            message: ts.availableCapacity,
            status: ts.available,
            type: SERVICE_TYPE.OMBORI,
            orderGUID: json.orderGUID,
          });
        } else {
          // IKEA
          timeslots.push({
            id: ts.id,
            date: ts.date,
            actual_date: ts.actual_date,
            start_time: ts.start_time,
            slotstart: ts.slotstart,
            end_time: ts.end_time,
            slotend: ts.slotend,
            message: ts.message,
            status: ts.status,
            type: "IKEA",
            orderGUID: json.orderGUID,
          });
        }
      });
    }

    log("fetchTimeslotsAsync", "response processed", timeslots);
    return timeslots; //.sort(sortTimeslotsBy("start_time"));
  }

  throw new Error(response.status);
}

// function sortTimeslotsBy(prop) {
//   return function (a, b) {
//     if (a[prop] > b[prop]) {
//       return 1;
//     } else if (a[prop] < b[prop]) {
//       return -1;
//     }

//     return 0;
//   };
// }

/*
{
  "id": "225107941_3476935",
  "date": "20200914",
  "actual_date": "2020-09-14T00:00:00",
  "start_time": "14:00:00",
  "slotstart": "2020-09-14T14:00:00",
  "end_time": "21:00:00",
  "slotend": "2020-09-14T21:00:00",
  "message": "",
  "status": "Success"
}
*/
